// extracted by mini-css-extract-plugin
export default {"a":"BackLink-module__a--uF2Nh","link":"BackLink-module__link--DDgrL","text":"BackLink-module__text--esTPD"};